import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLanguage24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLanguage24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 4h13v2.75a.75.75 0 0 1-1.5 0V5.5H9.25v10h1.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.5v-10H3.5v1.25a.75.75 0 0 1-1.5 0zm14.692 11.662.574-.38A3.87 3.87 0 0 0 19 12.057V10.5h-7.77V9h4.26V7.308a.75.75 0 0 1 1.5 0V9H22v1.5h-1.5v1.557a5.37 5.37 0 0 1-2.262 4.377l2.559 1.28a.75.75 0 1 1-.67 1.342l-3.33-1.665-3.614 2.389-.827-1.251 2.919-1.93a5.37 5.37 0 0 1-2.486-4.528v-.61h1.5v.61c0 1.464.827 2.802 2.136 3.457z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLanguage24);
